import { useEffect, useState } from 'react';
import { getTx } from './services/icon';
import Logs from './components/logs/Logs';
import Error from './components/error/Error';
import { useLocation } from 'react-router-dom';
import { Dropdown, DropdownMenu, DropdownItem, DropdownDivider } from './components/dropdown/Dropdown';
import SupportMe from './components/supportMe/SupportMe';
import { Analytics } from '@vercel/analytics/react';
import Note from './components/note/Note.component';
import ReleaseNote from './components/releaseNote/ReleaseNote';
function App() {
  const [logs, setLog] = useState(null);
  const [logs_error, setLogError] = useState([]);
  const [SERVER, setSERVER] = useState(['Mainnet', 'Sejong', 'Berlin', 'Lisbon', 'Custom']);

  const [tx, setTx] = useState(null);
  const [error, setError] = useState(false);
  const [CustomServer, setCustomServer] = useState('');

  const [selectedServer, setSelectedServer] = useState(
    window.localStorage.getItem('server')
      ? JSON.parse(window.localStorage.getItem('server'))
      : {
          sejong: false,
          berlin: false,
          mainnet: true,
          lisbon: false,
          custom: false,
        }
  );
  useEffect(() => {
    console.log(selectedServer);
    const urlParams = new URLSearchParams(window.location.search);
    const myParam = urlParams.get('tx');
    if (myParam) {
      setTx(myParam);
    }
    console.log(myParam);
  });
  useEffect(() => {
    if (tx) {
      getRes(tx, selectedServer.mainnet);
    }
  }, [tx]);
  const dropDownItemss = () => {};
  const checkError = (data) => {
    if (
      data.toUpperCase().includes('ERROR') ||
      data.toUpperCase().includes('FAILURE') ||
      data.toUpperCase().includes('INVALID') ||
      data.toUpperCase().includes('SUCCESS=FALSE') ||
      data.toUpperCase().includes('SYSTEMEXCEPTION') ||
      data.toUpperCase().includes('OUTOFSTEP') ||
      data.toUpperCase().includes('REVERTED') ||
      data.toUpperCase().includes('SCOREEXCEPTION') ||
      data.toUpperCase().includes('ONLY NFT OWNER') ||
      data.toUpperCase().includes('EXCEPTION')
    ) {
      return true;
    } else {
      return false;
    }
  };
  const getRes = async (tx, mainnet, sejong, berlin, lisbon, custom) => {
    let queryParams = new URLSearchParams(window.location.search);

    queryParams.set('tx', tx);

    console.log(queryParams);

    const re = await getTx(tx, mainnet, sejong, berlin, lisbon, custom, CustomServer);
    if (re) {
      setError(false);
      let err = [];
      await re.trace.logs.map((data) => {
        if (checkError(data.msg)) {
          err.push(data);
        }
      });
      setLog(re.trace.logs);
      setLogError(err);
    } else {
      setError(true);
    }
  };
  let btn = null;
  if (selectedServer.sejong) {
    btn = <button className='btn'>{'Sejong'}</button>;
  } else if (selectedServer.mainnet) {
    btn = <button className='btn'>{'Mainnet'}</button>;
  } else if (selectedServer.berlin) {
    btn = <button className='btn'>{'Berlin'}</button>;
  } else if (selectedServer.lisbon) {
    btn = <button className='btn'>{'Lisbon'}</button>;
  } else if (selectedServer.custom) {
    btn = <button className='btn'>{'Custom'}</button>;
  }
  const [modalIsOpen, setIsOpen] = useState(false);

  function openModal() {
    console.log();
    setIsOpenReleaseNote(false);
    setIsOpen(true);
  }

  function closeModal() {
    setIsOpen(false);
  }
  const [modalIsOpenReleaseNote, setIsOpenReleaseNote] = useState(false);

  function openModalReleaseNote() {
    setIsOpen(false);
    setIsOpenReleaseNote(true);
  }

  function closeModalReleaseNote() {
    setIsOpenReleaseNote(false);
  }
  const [modalIsOpenNotice, setIsOpenNotice] = useState(
    window.localStorage.getItem('notice') ? (window.localStorage.getItem('notice') == 'old' ? false : true) : true
  );

  function openModalNotice() {
    setIsOpen(false);
    setIsOpenNotice(true);
  }
  function openModalNotice() {
    setIsOpen(false);
    setIsOpenNotice(true);
  }
  function closeModalNotice() {
    window.localStorage.getItem('notice');
    window.localStorage.setItem(`notice`, 'old');
    setIsOpenNotice(false);
  }

  function setHistory(serverName) {
    if (serverName == 'Mainnet') {
      window.localStorage.removeItem('server');
      window.localStorage.setItem(
        `server`,
        JSON.stringify({
          sejong: false,
          berlin: false,
          mainnet: true,
          lisbon: false,
          custom: false,
        })
      );
    } else if (serverName == 'Sejong') {
      window.localStorage.removeItem('server');
      window.localStorage.setItem(
        `server`,
        JSON.stringify({
          sejong: true,
          berlin: false,
          mainnet: false,
          lisbon: false,
          custom: false,
        })
      );
    } else if (serverName == 'Berlin') {
      window.localStorage.removeItem('server');
      window.localStorage.setItem(
        `server`,
        JSON.stringify({
          sejong: false,
          berlin: true,
          mainnet: false,
          lisbon: false,
          custom: false,
        })
      );
    } else if (serverName == 'Lisbon') {
      window.localStorage.removeItem('server');
      window.localStorage.setItem(
        `server`,
        JSON.stringify({
          sejong: false,
          berlin: false,
          mainnet: false,
          lisbon: true,
          custom: false,
        })
      );
    } else if (serverName == 'Custom') {
      window.localStorage.removeItem('server');
      window.localStorage.setItem(
        `server`,
        JSON.stringify({
          sejong: false,
          berlin: false,
          mainnet: false,
          lisbon: false,
          custom: true,
        })
      );
    }
  }
  return (
    <>
      {/* <div className='crafter_details'>
        <div >Wanna make this tools better?</div>
      </div> */}
      <div className='App'>
        {/* <div onClick={openModal} className='note_whatsnew'>
          What's new?
        </div> */}
        <Note
          className={'ReleaseNote'}
          modalIsOpen={modalIsOpenReleaseNote}
          openModal={openModalReleaseNote}
          title={`What's new?`}
        >
          <ReleaseNote
            modalIsOpen={modalIsOpenReleaseNote}
            openModal={openModalReleaseNote}
            closeModal={closeModalReleaseNote}
            setIsOpen={setIsOpenReleaseNote}
          />
        </Note>

        <Note className={'SupportMeNote'} modalIsOpen={modalIsOpen} openModal={openModal} title={`Support us?`}>
          <SupportMe modalIsOpen={modalIsOpen} openModal={openModal} closeModal={closeModal} setIsOpen={setIsOpen} />
        </Note>
        {/* <div onClick={openModal} className='note'>
          Support us?
        </div> */}
        <div className='server-input'>
          <div className='input-btn'>
            <div className='form'>
              <input
                type='text'
                name='txHash'
                autoComplete='off'
                value={tx}
                required
                onChange={(e) => {
                  setTx(e.target.value);
                }}
                onKeyDown={(e) => {
                  if (e.key === 'Enter') {
                    getRes(
                      tx,
                      selectedServer.mainnet,
                      selectedServer.sejong,
                      selectedServer.berlin,
                      selectedServer.lisbon,
                      selectedServer.custom
                    );
                  }
                }}
              />
              <label className='label-name'>
                <span className='content-name'>TxHash</span>
              </label>
            </div>
            <button
              onClick={(e) => {
                if (tx) {
                  getRes(
                    tx,
                    selectedServer.mainnet,
                    selectedServer.sejong,
                    selectedServer.berlin,
                    selectedServer.lisbon,
                    selectedServer.custom
                  );
                }
              }}
            >
              Trace
            </button>
          </div>

          <div className='server'>
            {selectedServer.custom ? (
              <input
                type='text'
                onChange={(e) => {
                  setCustomServer(e.target.value);
                }}
              />
            ) : null}
            <Dropdown toggle={btn}>
              <DropdownMenu>
                {SERVER.map((serverName, index) => {
                  return (
                    <>
                      <DropdownItem
                        onClick={(e) => {
                          // 'Mainnet', 'Sejong', 'Berlin', 'Lisbon','Custom'
                          const serverName = e.target.textContent;
                          console.log(serverName);
                          setHistory(serverName);
                          if (serverName == 'Mainnet') {
                            setSelectedServer((res) => {
                              return {
                                sejong: false,
                                berlin: false,
                                mainnet: true,
                                lisbon: false,
                                custom: false,
                              };
                            });
                          } else if (serverName == 'Sejong') {
                            setSelectedServer((res) => {
                              return {
                                sejong: true,
                                berlin: false,
                                mainnet: false,
                                lisbon: false,
                                custom: false,
                              };
                            });
                          } else if (serverName == 'Berlin') {
                            setSelectedServer((res) => {
                              return {
                                sejong: false,
                                berlin: true,
                                mainnet: false,
                                lisbon: false,
                                custom: false,
                              };
                            });
                          } else if (serverName == 'Lisbon') {
                            setSelectedServer((res) => {
                              return {
                                sejong: false,
                                berlin: false,
                                mainnet: false,
                                lisbon: true,
                                custom: false,
                              };
                            });
                          } else if (serverName == 'Custom') {
                            setSelectedServer((res) => {
                              return {
                                sejong: false,
                                berlin: false,
                                mainnet: false,
                                lisbon: false,
                                custom: true,
                              };
                            });
                          }
                        }}
                      >
                        {serverName}
                      </DropdownItem>
                      <DropdownDivider />
                    </>
                  );
                })}
              </DropdownMenu>
            </Dropdown>
          </div>
        </div>
        {error ? <Error /> : <Logs checkError={checkError} logs_error={logs_error} logs={logs} />}
      </div>
      <Analytics />
      <ReleaseNote
        modalIsOpen={modalIsOpenNotice}
        openModal={openModalNotice}
        closeModal={closeModalNotice}
        setIsOpen={setIsOpenNotice}
      />
    </>
  );
}

export default App;
